import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import Header from '../../../components/Header/Header';
import Form from '../../../components/Form/Form';
import Button from '../../../components/Button/Button';
import Breadcrumbs from '../../../components/Breadcrumbs';

// icons
import icon from '../../../brand/generated/sidebar/report.svg';
import HookForm from '../../../components/HookForm/HookForm';
import Select from '../../../components/Select/Select';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import DownloadFileLink from '../../../components/DownloadFileLink/DownloadFileLink';
import alert from '../../../helpers/alert';
import downloadReport from '../../../api/reports/downloadReport';

/** Сохраняет полученный файл: отдаём его браузеру под понятным именем. */
const saveFile = (blob, title, from, to) => {
  const name = [title || 'Отчет', from, to].filter(Boolean).join(' ') + '.xlsx';
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Ссылку держит браузер, пока её не освободить, — файл остаётся в памяти.
  window.URL.revokeObjectURL(url);
};

const formStyles = {
  report: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a a' 'c c b b'` },
};

// Список отчетов
const reportOptions = [
  { id: 1, title: 'Список успешных сделок' },
  { id: 2, title: 'Список сделок с одобрением банков' },
  { id: 3, title: 'Список отказанных сделок' },
  { id: 4, title: 'Клиенты, успешно прошедшие БМГ проверку' },
  { id: 5, title: 'Клиенты, прошедшие БМГ тест и получившие отказ' },
  { id: 6, title: 'Клиенты, которым дважды отказали все банки' },
  { id: 7, title: 'Воронка мобильного приложения' },
  { id: 8, title: 'Воронка Halyk Market' },
  // Партнёрские контуры опрашиваются ночью: из брокера до их баз не дотянуться.
  { id: 9, title: 'Серые дилеры: заявки по контурам' },
];

const formData = [
  {
    component: Datepicker,
    name: 'from',
    label: 'Отчетный период с',
    placeholder: 'дд-мм-гггг',
    rules: {
      required: true,
    },
  },
  {
    component: Datepicker,
    name: 'to',
    label: 'Отчетный период до',
    placeholder: 'дд-мм-гггг',
    rules: {
      required: true,
    },
  },
  {
    component: Select,
    label: 'Тип отчета',
    name: 'reportType',
    options: reportOptions.map((r) => ({ value: r.id, label: r.title })),
    placeholder: 'Выберите отчет',
    rules: {
      required: true,
    },
  },
]

const ReportCreate = () => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (values) => {
    setLoading(true);

    try {
      // Запрос идёт через наш бэкенд: он сам ходит в админку и отдаёт готовый
      // файл. Раньше браузер менеджера стучался на admin.doscar.kz напрямую, и
      // у тех, у кого нет доступа к админке, скачивание падало. Заодно тестовый
      // контур перестал забирать отчёты из боевой админки.
      const response = await downloadReport({
        id: values?.reportType?.value,
        title: values?.reportType?.label,
        date: { from: values?.from, to: values?.to },
      });

      saveFile(response.data, values?.reportType?.label, values?.from, values?.to);
    } catch (error) {
      alert.error(error);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header title="Новый отчет" icon={icon} />
      <Breadcrumbs navigate={'/reports'} link={'Мои отчеты'} currentPage={'Новый отчет'} />
      <HookForm
        inputs={formData}
        title={'Отчет'}
        grid={formStyles.report}
        onSubmit={handleDownload}
        border
        action="Сформировать отчет"
        loading={loading}
      />
    </>
  );
};

export default ReportCreate;
